import { useCensusUploadCheckEnabled } from "@platform/census-validation";
import { useUser } from "@platform/user/client";

/**
 * Whether the signed-in broker's census uploads are checked. A broker carries
 * its external id or, signed in through Salesforce, its Salesforce id; the
 * pilot flag may list either.
 */
export const useCensusCheckForBroker = (): boolean => {
  const { user } = useUser();
  const brokerIds =
    user.status === "signedIn"
      ? [user.brokerId, user.sfBrokerId].filter(
          (id): id is string => typeof id === "string" && id !== "",
        )
      : [];

  return useCensusUploadCheckEnabled(brokerIds);
};
